<app-menu></app-menu>
<mat-toolbar class="flexSpace" color="primary">
  Manage asset profiles
</mat-toolbar>
<mat-card>
<table
mat-table
[dataSource]="dataSource"
>
<ng-container matColumnDef="disId">
  <th mat-header-cell *matHeaderCellDef>DisId</th>
  <td mat-cell *matCellDef="let row">{{ row.disId }}</td>
</ng-container>
<ng-container matColumnDef="pathName">
  <th mat-header-cell *matHeaderCellDef>Path</th>
  <td mat-cell *matCellDef="let row">{{ row.pathName }}</td>
</ng-container>
<ng-container matColumnDef="content">
  <th mat-header-cell *matHeaderCellDef>File content</th>
  <td mat-cell *matCellDef="let row"><button mat-raised-button color="accent" (click)="showFileContent(row.content)">Show</button></td>
</ng-container>
<ng-container matColumnDef="reprocess">
  <th mat-header-cell *matHeaderCellDef>Reprocess</th>
  <td mat-cell *matCellDef="let row"><button mat-raised-button color="accent" (click)="reprocess(row.disId)">Reprocess</button></td>
</ng-container>

<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

</table>
</mat-card>
